module.exports = __webpack_public_path__ + "img/30077195_2066750973610181_3733150062893596672_n.52a4b071.jpg";